import styled, { css } from 'styled-components';


export const MenuInnerContainer = styled.div`
	position: relative;

	display: flex;
	flex-direction: column;
	align-items: flex-start;

	margin-left: auto;
	margin-right: auto;

	margin-top: 30px;	/* Space needed for website menu */

	height: 100%;
	max-height: 100%;

	width: 90%;
	min-width: 360px;
	max-width: 100%;
`;

export const MenuHeaderContent = styled.div`
`;

export const MenuMainContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100%;
	max-height: 100%;
	overflow: auto;
	pointer-events: auto;
`;

export const MenuContainer = styled.div<{mobile:boolean, menuHeight:number}>`
	position: relative;
	width: 35%;
	min-width: 500px;
	max-width: 1000px;
	height: 100%;
	
	background-color: white;
	
	box-sizing: border-box;
	
	display: flex;
	flex-direction: column;
	justify-content: inherit;

	user-select: none;

	font-family: 'Soehne Breit', sans-serif;
  
	${(props) => props.mobile && css`
		height: 50%;
		width: auto;
		min-width: unset;
		max-width: 100%;
		border: unset;
		z-index: 12;

		& ${MenuInnerContainer} {
			margin-top: 0px;
			bottom: 0px;
			position: absolute;
			width: 100%;
			background-color: white;
			min-width: unset;
		};
	`};

	${(props) => props.menuHeight < 400 && css`
		& ${MenuMainContent} {
			display: block;
		};
	`};
`;